import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import USMap from '../components/USMap';
import DataContainer from './DataContainer';

import * as actionCreators from '../actions/CombinedActions';

import '../style/style.css';

const mapStateToProps = state => (
  {
    states: state.StateNames.states,
  }
);

const mapDispatchToProps = dispatch => (
    { actions: bindActionCreators(actionCreators, dispatch) }
);

const DataAndMap = ({ states, actions }) => (
  <div className="container">
    <USMap
      CheckSelection={actions.CheckSelection}
      states={states}
    />
    <DataContainer />
  </div>
);

DataAndMap.propTypes = {
  states: PropTypes.arrayOf(PropTypes.object).isRequired,
  actions: PropTypes.objectOf(PropTypes.func.isRequired).isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DataAndMap);



// WEBPACK FOOTER //
// ./src/containers/DataAndMap.js